/**
 * Names the organisation whose products to open on arrival at
 * /admin/organisations. A link from elsewhere, such as the product visibility
 * notice, then lands the user on the setting itself, not on a list to search.
 */
export const MANAGE_PRODUCTS_PARAM = 'manageProducts';
